import { render, staticRenderFns } from "./embeddedPopupNew.vue?vue&type=template&id=3513175a&scoped=true&"
import script from "./embeddedPopupNew.vue?vue&type=script&lang=ts&"
export * from "./embeddedPopupNew.vue?vue&type=script&lang=ts&"
import style0 from "./embeddedPopupNew.vue?vue&type=style&index=0&id=3513175a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3513175a",
  null
  
)

export default component.exports